export class VW_SERIES_SA {
    constructor(
        public SS_ID: number,
        public SERIES_ID: number,
        public PA_ID: number,
        public PA_NAME: string,
        public SA_CODE: string,
        public TARGET: number,
        public CREATED_BY: Date,
        public INST_TYPE_NAME: string,
        public CHECKED: boolean,
        public CG_STATUS: number,
        public CD_STATUS: string
    ) { }
}

export class NEW_SERIES_SA {
    constructor(
        public SS_ID: number,
        public SERIES_ID: number,
        public PA_ID: number,
        public PA_NAME: string,
        public SA_CODE: string,
        public TARGET: number,
        public CREATED_BY: Date,
        public PARENT_ID: number,
        public CG_INST_TYPE: number,
        public CD_INST_TYPE: string,
        public CONFIRM_BY: number
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/seriessa.ts